import { Modifier } from '../modifier';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Stunned extends Modifier {
  static readonly baseTitle = 'Stunned';
  static readonly baseText = 'Cancel next technique used, then fade.';
  static readonly baseIcon = 'stun';
  static readonly baseTags = [ModifierTags.Boon];
  static readonly basePriority = ModifierPriority.First;

  // Instance properties that can change
  title = Stunned.baseTitle;
  text = Stunned.baseText;
  icon = Stunned.baseIcon;
  tags: Array<ModifierTags> = [...Stunned.baseTags];
  priority = Stunned.basePriority;

  canUseTechnique() {
    this.removeStacks(1);

    return { able: false };
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Stunned, Stunned);
